import { HttpErrorResponse } from '@angular/common/http';

import { titleCase } from '../../utils/strings';

export class APIError implements Error {
  message: string;
  name: string;
  stack?: string | undefined;
  status: number;

  constructor(error: HttpErrorResponse) {
    this.name = error.error || 'APIError';
    this.status = error.status;

    if (typeof error?.error === 'string') {
      this.message = titleCase(error.error);
    } else {
      this.message = error.error?.message || error.error?.Message || error.error?.datas?.Message || error.statusText;
    }
  }

  get errorName(): string {
    return this.message;
  }
}
